import { MessageCircle, Phone, Mail, Instagram, MapPin, Clock } from "lucide-react";
import { Reveal } from "@/components/Reveal";
import { EnquiryForm } from "@/components/EnquiryForm";
import { CONTACT } from "@/data/content";

const CHANNELS = [
    { testid: "contact-whatsapp-btn", href: CONTACT.whatsappHref, icon: MessageCircle, label: "WhatsApp", value: CONTACT.phoneDisplay, hint: "Fastest reply", external: true },
    { testid: "contact-phone-btn", href: CONTACT.phoneHref, icon: Phone, label: "Call the Studio", value: CONTACT.phoneDisplay, hint: "Mon–Sat, 10am–7pm", external: false },
    { testid: "contact-email-btn", href: CONTACT.emailHref, icon: Mail, label: "Write to Us", value: CONTACT.email, hint: "Briefs & documents", external: false },
    { testid: "contact-instagram-btn", href: CONTACT.instagramHref, icon: Instagram, label: "Instagram", value: CONTACT.instagram, hint: "Site diaries & details", external: true },
];

const DETAILS = [
    { icon: MapPin, label: "Studio", value: "Kolkata, West Bengal, India" },
    { icon: Clock, label: "Hours", value: "Monday – Saturday · 10:00 – 19:00 IST" },
];

export const Contact = () => (
    <section id="contact" data-testid="contact-section" className="border-t border-wood/10 pb-20 lg:pb-32">
        <div className="mx-auto max-w-7xl px-6 pt-16 sm:px-12 lg:px-20 lg:pt-24">
            <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4">
                {CHANNELS.map((c, i) => (
                    <Reveal key={c.testid} delay={0.08 * i} y={20}>
                        <a
                            data-testid={c.testid}
                            href={c.href}
                            {...(c.external ? { target: "_blank", rel: "noreferrer" } : {})}
                            className="group flex h-full flex-col border border-wood/15 bg-ivory p-7 transition-colors duration-500 hover:border-terra hover:bg-sand"
                        >
                            <c.icon size={20} strokeWidth={1.5} className="text-terra" />
                            <span className="mt-8 text-xs uppercase tracking-[0.2em] text-mute transition-colors duration-300 group-hover:text-terra">
                                {c.label}
                            </span>
                            <span className="mt-2 break-all font-serif text-xl text-ink">{c.value}</span>
                            <span className="mt-4 font-mono text-[10px] uppercase tracking-[0.2em] text-fog">{c.hint}</span>
                        </a>
                    </Reveal>
                ))}
            </div>
            <div className="mt-16 grid grid-cols-1 gap-10 border-t border-wood/10 pt-12 lg:grid-cols-12 lg:gap-16">
                <Reveal className="lg:col-span-5">
                    <h2 className="font-serif text-2xl font-normal leading-snug tracking-tight text-ink sm:text-3xl">
                        Or leave your details — <em className="text-terra">we'll call you.</em>
                    </h2>
                    <p className="mt-6 text-base font-light leading-relaxed text-mute">
                        Tell us about your space, your routines, and how you like to live. We’ll
                        arrange a first meeting—at your site or at the studio—and take it from there.
                    </p>
                    <ul className="mt-10 divide-y divide-wood/10 border-y border-wood/10">
                        {DETAILS.map((d) => (
                            <li key={d.label} className="flex items-center gap-6 py-5">
                                <d.icon size={16} strokeWidth={1.5} className="text-terra" />
                                <span className="w-20 font-mono text-[10px] uppercase tracking-[0.25em] text-fog">{d.label}</span>
                                <span className="text-base text-ink">{d.value}</span>
                            </li>
                        ))}
                    </ul>
                </Reveal>
                <Reveal delay={0.15} className="lg:col-span-7">
                    <EnquiryForm source="contact" />
                </Reveal>
            </div>
        </div>
    </section>
);
